import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import type { FinishProjectSummary } from "./models";

interface FinishIllustrationProps {
  summary: FinishProjectSummary;
}

const FinishIllustration = ({ summary }: FinishIllustrationProps) => {
  return (
    <svg
      width="307"
      height="260"
      viewBox="0 0 4061 3451"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>
        <Trans>Project finish illustration</Trans>
      </title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2362.89 3450.9L2332.64 3427.34C2204.18 3327.3 2197.56 3135.4 2318.81 3026.74C2409.43 2945.55 2544.1 2937.67 2643.56 3007.74L2695.09 3044.05V2935.66C2695.09 2764.8 2833.61 2626.28 3004.47 2626.28H3026.17C3186.38 2626.28 3320.08 2748.58 3334.33 2908.15L3493.15 2762.74C3554.73 2706.36 3645.3 2695.27 3718.67 2735.11C3819.98 2790.14 3852 2920.39 3787.74 3016.12L3752.09 3069.21L3822.11 3060.7C3926.51 3047.99 4024.5 3113.59 4052.54 3214.97L4052.8 3215.92C4077.54 3305.35 4041.38 3400.48 3963.49 3450.9H2362.89"
        fill="#EAEAEA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M276.009 3450.45L171.534 3449.09C69.421 3447.75 -8.322 3357.07 5.954 3255.95C18.933 3164.02 103.465 3099.65 195.536 3111.59L265.271 3120.63C280.512 3122.6 291.74 3106.7 284.78 3093L213.615 2952.89C172.007 2870.98 199.838 2770.85 277.75 2722.16C358.365 2671.77 464.368 2693.9 518.092 2772.33L592.53 2881C602.588 2895.68 625.49 2889.87 627.329 2872.17L637.756 2771.76C649.265 2660.95 747.95 2580.13 858.86 2590.69C978.12 2602.05 1061.64 2713.68 1038.88 2831.29L1029.19 2881.35C1026.03 2897.67 1043.77 2909.97 1057.95 2901.29L1140.96 2850.46C1213.99 2805.75 1308.65 2820.49 1364.64 2885.28C1427.79 2958.36 1419.76 3068.79 1346.69 3131.96C1333.29 3143.54 1341.49 3165.55 1359.2 3165.55H1461.13C1538.85 3165.55 1601.85 3228.55 1601.85 3306.26C1601.85 3383.82 1546.46 3450.23 1468.91 3450.45H276.009"
        fill="#EAEAEA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2220.5 740.31H2243.19V0.757996H2220.5V740.31Z"
        fill="#383838"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3831.71 3450.9H632.151L2231.93 680.01L2733.06 1548H2733.07L3831.71 3450.9"
        fill="#3A7995"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2733.06 1548L2499.91 1471.43L2231.93 1572.74L1942.51 1471.43L1716.51 1572.74L2231.93 680.01L2733.06 1548"
        fill="#256480"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2798.31 2891.48L1507.09 3450.9H1345.33L2667.81 2877.93L1789.05 2256.08L2474.81 1564.45L2201.63 794.68L2262.23 773.17L2548.95 1581.03L1888.18 2247.46L2798.31 2891.48"
        fill="#C5D8E1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2892.08 2884.71C2892.08 2972.54 2820.88 3043.74 2733.06 3043.74C2645.23 3043.74 2574.03 2972.54 2574.03 2884.71C2574.03 2796.88 2645.23 2725.69 2733.06 2725.69C2820.88 2725.69 2892.08 2796.88 2892.08 2884.71"
        fill={summary.pointColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2809.42 2884.71C2809.42 2926.89 2775.23 2961.08 2733.06 2961.08C2690.88 2961.08 2656.69 2926.89 2656.69 2884.71C2656.69 2842.54 2690.88 2808.34 2733.06 2808.34C2775.23 2808.34 2809.42 2842.54 2809.42 2884.71"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2763.2 2884.71C2763.2 2901.36 2749.71 2914.85 2733.06 2914.85C2716.41 2914.85 2702.92 2901.36 2702.92 2884.71C2702.92 2868.06 2716.41 2854.57 2733.06 2854.57C2749.71 2854.57 2763.2 2868.06 2763.2 2884.71"
        fill={summary.pointColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1838.61 2410.8C1750.79 2410.8 1679.59 2339.6 1679.59 2251.77C1679.59 2163.95 1750.79 2092.75 1838.61 2092.75C1926.44 2092.75 1997.64 2163.95 1997.64 2251.77C1997.64 2339.6 1926.44 2410.8 1838.61 2410.8Z"
        fill={summary.point2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1914.98 2251.77C1914.98 2293.95 1880.79 2328.14 1838.61 2328.14C1796.44 2328.14 1762.25 2293.95 1762.25 2251.77C1762.25 2209.6 1796.44 2175.41 1838.61 2175.41C1880.79 2175.41 1914.98 2209.6 1914.98 2251.77"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1868.76 2251.77C1868.76 2268.42 1855.26 2281.92 1838.61 2281.92C1821.97 2281.92 1808.47 2268.42 1808.47 2251.77C1808.47 2235.12 1821.97 2221.63 1838.61 2221.63C1855.26 2221.63 1868.76 2235.12 1868.76 2251.77"
        fill={summary.point2Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2670.9 1572.74C2670.9 1660.57 2599.71 1731.77 2511.88 1731.77C2424.05 1731.77 2352.85 1660.57 2352.85 1572.74C2352.85 1484.91 2424.05 1413.72 2511.88 1413.72C2599.71 1413.72 2670.9 1484.91 2670.9 1572.74"
        fill={summary.point1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2588.25 1572.74C2588.25 1614.92 2554.05 1649.11 2511.88 1649.11C2469.7 1649.11 2435.51 1614.92 2435.51 1572.74C2435.51 1530.56 2469.7 1496.37 2511.88 1496.37C2554.05 1496.37 2588.25 1530.56 2588.25 1572.74"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2542.02 1572.74C2542.02 1589.39 2528.53 1602.88 2511.88 1602.88C2495.23 1602.88 2481.74 1589.39 2481.74 1572.74C2481.74 1556.09 2495.23 1542.6 2511.88 1542.6C2528.53 1542.6 2542.02 1556.09 2542.02 1572.74"
        fill={summary.point1Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2390.95 783.92C2390.95 871.75 2319.75 942.95 2231.93 942.95C2144.1 942.95 2072.9 871.75 2072.9 783.92C2072.9 696.1 2144.1 624.9 2231.93 624.9C2319.75 624.9 2390.95 696.1 2390.95 783.92"
        fill={summary.point3Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2308.29 783.92C2308.29 826.1 2274.1 860.29 2231.93 860.29C2189.75 860.29 2155.56 826.1 2155.56 783.92C2155.56 741.75 2189.75 707.56 2231.93 707.56C2274.1 707.56 2308.29 741.75 2308.29 783.92"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2262.07 783.92C2262.07 800.57 2248.58 814.07 2231.93 814.07C2215.28 814.07 2201.79 800.57 2201.79 783.92C2201.79 767.28 2215.28 753.78 2231.93 753.78C2248.58 753.78 2262.07 767.28 2262.07 783.92"
        fill={summary.point3Color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M818.95 3346.77C806.62 3346.77 794.79 3348.92 783.84 3352.87C757.66 3315.44 714.23 3290.95 665.081 3290.95C615.542 3290.95 571.816 3315.82 545.697 3353.77C534.064 3349.25 521.42 3346.77 508.197 3346.77C450.929 3346.77 404.514 3393.19 404.514 3450.45H922.64C922.64 3393.19 876.21 3346.77 818.95 3346.77"
        fill="#256480"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3784.57 3346.77C3772.25 3346.77 3760.42 3348.92 3749.46 3352.87C3723.29 3315.44 3679.86 3290.95 3630.71 3290.95C3581.17 3290.95 3537.44 3315.82 3511.32 3353.77C3499.69 3349.25 3487.05 3346.77 3473.82 3346.77C3416.56 3346.77 3370.14 3393.19 3370.14 3450.45H3888.27C3888.27 3393.19 3841.84 3346.77 3784.57 3346.77"
        fill="#256480"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M421.482 2468.11L348.265 3423.63H273.563L216.475 2608.79C216.351 2606.71 212.977 2606.6 212.667 2608.67L91.186 3423.63H20.879L37.566 2468.11H421.482"
        fill="#212121"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M258.663 1652.58V1606.58C258.663 1594.87 269.32 1585.38 282.466 1585.38C295.612 1585.38 306.269 1594.87 306.269 1606.58V1735.77C306.269 1747.48 295.612 1756.97 282.466 1756.97C269.32 1756.97 258.663 1747.48 258.663 1735.77V1693.03C246.124 1693.03 235.959 1683.98 235.959 1672.8C235.959 1661.63 246.124 1652.58 258.663 1652.58"
        fill="#F7CFA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271.114 1754.41L275.508 1811.12H171.142L184.691 1725L258.663 1693.03L271.114 1754.41"
        fill="#F7CFA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M263.028 1717.68L256.037 1761.28C255.652 1763.68 253.438 1765.45 250.83 1765.45H192.856C191.12 1765.45 189.468 1764.79 188.279 1763.61C176.22 1751.69 111.966 1683.57 142.396 1614.25C175.903 1537.91 283.564 1565.31 317.072 1530.08C317.072 1530.08 357.719 1567.76 312.128 1603.97C312.128 1603.97 296.196 1614.44 270.669 1618.3C267.497 1618.78 265.01 1621.1 264.418 1624.03L258.663 1652.58C258.663 1652.58 239.1 1652.38 236.156 1670.18C236.156 1670.18 233.029 1691.4 258.663 1693.03L262.956 1714.19C263.189 1715.34 263.214 1716.52 263.028 1717.68"
        fill="#191919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M558.473 2138.51C553.334 2153.79 537.36 2171 490.086 2164.09C482.253 2162.94 475.226 2161.88 468.941 2160.9C422.999 2153.7 415.538 2150.71 414.454 2149.76L414.424 2149.73L414.3 2149.59L402.474 2279.79C402.288 2281.6 402.318 2283.42 402.504 2285.23L421.977 2471.39C421.977 2471.39 340.556 2494.7 223.348 2494.87H223.316C164.124 2494.96 95.829 2489.11 24.285 2471.39L66.203 2191.46C68.989 2172.73 67.781 2153.7 62.642 2135.37L1.654 1918.05C-2.184 1904.35 2.83 1889.93 14.594 1880.49C42.055 1858.56 99.39 1819.13 185.795 1790.92C205.608 1784.45 227.279 1784.1 247.403 1789.66L426.931 1839.22C442.503 1843.5 454.855 1854.07 460.334 1867.74L557.451 2110.68C561.011 2119.63 561.538 2129.38 558.473 2138.51"
        fill="#EEC200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M273.563 3423.63H348.267C348.267 3423.63 442.196 3446.63 430.661 3448.58C419.126 3450.54 273.563 3448.58 273.563 3448.58C273.563 3448.58 268.07 3435.37 273.563 3423.63"
        fill="#DAB201"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.186 3449.44H20.879C20.879 3449.44 15.399 3435.37 20.879 3423.63H91.186C91.186 3423.63 93.941 3440.55 91.186 3449.44"
        fill="#DAB201"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M468.941 2160.9C422.999 2153.7 415.538 2150.71 414.454 2149.76L414.424 2149.73L414.3 2149.41L421.482 2042.49C421.482 2042.49 426.095 2140.75 468.941 2160.9"
        fill="#DAB201"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M952.26 908.62C934.79 908.62 918.39 913.23 904.22 921.31C887.04 879.51 845.91 850.06 797.9 850.06C778.54 850.06 760.31 854.85 744.31 863.31C719.66 816.14 670.271 783.92 613.353 783.92C541.802 783.92 482.15 834.82 468.602 902.37C456.307 896.74 442.64 893.61 428.233 893.61C374.584 893.61 331.096 937.1 331.096 990.76H1048.26C1041.04 944.23 1000.81 908.62 952.26 908.62"
        fill="#256480"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3676.9 360.45C3670.08 360.45 3663.4 361.05 3656.92 362.208C3638.03 300.358 3580.51 255.37 3512.48 255.37C3446.29 255.37 3390.04 297.957 3369.67 357.223C3354.33 348.68 3336.66 343.824 3317.86 343.824C3275.57 343.824 3239.03 368.403 3221.73 404.055C3208.78 395.748 3193.38 390.935 3176.86 390.935C3130.9 390.935 3093.64 428.195 3093.64 474.147H3790.61C3790.61 411.355 3739.7 360.45 3676.9 360.45"
        fill="#256480"
      />
      <svg>
        <title>
          <Trans>Flag clip path definition</Trans>
        </title>
        <defs>
          <clipPath id="flagMask">
            <path id="mask" d="M2243 312H2617L2548 172L2617 32H2243V312Z" />
          </clipPath>
        </defs>
      </svg>
      <g clipPath="url(#flagMask)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          id="flag"
          fill={summary.flagColor}
          d="M2616.91 297.819C2616.91 297.819 2542.5 271.71 2444 297.819C2326 329.096 2243 297.819 2243 297.819V44.873C2243 44.873 2364.5 84.7062 2444 49.2062C2538 13.2062 2616.91 44.873 2616.91 44.873M2617 297.819C2617 297.819 2700 329.096 2818 297.819C2916.5 271.71 2990.91 297.819 2990.91 297.819V44.873C2990.91 44.873 2912 13.2062 2818 49.2062C2738.5 84.7062 2617 44.873 2617 44.873"
        />
      </g>
    </svg>
  );
};

export default observer(FinishIllustration);
